// Generated by CoffeeScript 2.7.0
import {
  buildInputRules
} from 'prosemirror-example-setup';

import schema from './schema.js';

export default buildInputRules(schema);
